import { env } from 'next-runtime-env';

export const getSentryCommonConfig = () => ({
  enabled:
    env('NEXT_PUBLIC_SENTRY_ENABLED') === 'true' &&
    !!env('NEXT_PUBLIC_SENTRY_DSN_URL'),
  environment: env('NEXT_PUBLIC_OURA_ENV'),
  release: env('NEXT_PUBLIC_VERSION') ?? 'local',
  dsn: env('NEXT_PUBLIC_SENTRY_DSN_URL'),

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  sendDefaultPii: false,
});
